import React, { useEffect, useState } from 'react';
import MostrarResultados from '../componentes/MostrarResultados';
import { socket } from '../socket';

const ResultadosBarra = () => {

    const [aparato, setAparato] = useState('');
    const [results, setResults] = useState([]);
    const [nivel, setNivel] = useState('');
    const [categoria, setCategoria] = useState('');

    useEffect(() => {
        socket.on('barraresult', data => {
            if (data.aparato === 'Barra' && data.results.length > 0 ) {
                setAparato(data.aparato);
                setResults(data.results);
                setNivel(data.nivel);
                setCategoria(data.categoria);
            }
        });
    }, []);

    return (
        <div>
            <MostrarResultados aparato={aparato} results={results} nivel={nivel} categoria={categoria}/>
        </div>
    );
};

export default ResultadosBarra;